// Track email link clicks
document.addEventListener('DOMContentLoaded', function() {
  var emailLinks = document.querySelectorAll('a[href^="mailto:"]');
  emailLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var emailLinkUrl = this.href;
      var emailLinkText = this.text;
      Shopify.analytics.publish('email_link', { link_url: emailLinkUrl });
    });
  });
});